import { render, staticRenderFns } from "./despre-noi.vue?vue&type=template&id=213b12a5&scoped=true"
import script from "./despre-noi.vue?vue&type=script&lang=js"
export * from "./despre-noi.vue?vue&type=script&lang=js"
import style0 from "./despre-noi.vue?vue&type=style&index=0&id=213b12a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213b12a5",
  null
  
)

export default component.exports